import emptyRoom from "./emptyRoom";
import validateRoom from './roomValidation';

export default function resetAssignment(debatersToAssign, rooms) {
    let positions = ["Panel", "Chair", "Opening Government", "Opening Opposition", "Closing Government", "Closing Opposition"];
    for (let room in rooms) {
        positions.forEach(position => {
            while (rooms[room][position].length > 0) {
                debatersToAssign.push(rooms[room][position].pop());
            }
        });
    }
    let newEmptyRoom = JSON.parse(JSON.stringify(emptyRoom));
    newEmptyRoom = validateRoom(newEmptyRoom);
    rooms = [newEmptyRoom];
    return {debatersToAssign, rooms}
}